class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.qtyRule = this.closest('product-info')?.querySelector('.quantity__rules-cart');
    this.optionsList = this.querySelectorAll('[data-option-position]');
  }

  /**
   * On load, if every option already has a selected value (e.g. a product with
   * only a colour option that is pre-selected, or any product whose options are
   * all auto-selected), enable the add to cart button. Products with an
   * unselected option (e.g. size) stay disabled until the user picks a value.
   */
  connectedCallback() {
    this.optionsList = this.querySelectorAll('[data-option-position]');
    if (!this.optionsList.length) return;

    const allChecked = Array.from(this.optionsList).every((option) => option.querySelector('input:checked'));
    if (!allChecked) return;

    this.onVariantChange({ target: this.querySelector('input:checked') });
  }

  /**
   * Handle the events when product variant changes.
   * @param {event} event
   */
  onVariantChange(event) {
    let allChecked = true;
    this.optionsList.forEach(option => {
      const checkedValue = option.querySelector('input:checked');
      if (!checkedValue) {
        allChecked = false;
      }
    });
    if (!allChecked) return false;


    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    // this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      (!this.closest('#quickViewModal') && !this.closest('#featureProductWrapper')) && this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      // this.updateShareUrl();
    }
  }

  /**
   * Function gives the all selected options values.
   */
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('[data-option-position]'), (element) => {
      return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
    });
  }

  /**
   * Function give the current activated variant.
   */
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    window.productData.currentVariant = this.currentVariant;
  }

  /**
   * Change the active option value next to option label, when variant change.
   * @param {event} event 
   */
  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;
    if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  /**
   * Updates the browser URL on variant change.
   */
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  /**
   * Handles the product sharing URL on variant change.
   */
  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  /**
   * Updates the current variant id in product form and payment forms, on variant change
   */
  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /**
   * Function return the all active variants list, on variant change.
   */
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('[data-option-position]')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  /**
   * Function disable the sold out options on variant change.
   * @param {Array} elementList 
   * @param {String} availableValuesList 
   */
  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        !availableElement ? element.setAttribute('disabled', 'disabled') : element.removeAttribute('disabled');
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  /**
   * Update the product media when variant updates
   */
  updateMedia() {
    var layoutStyle = document.querySelector('.product-media-wrapper')?.dataset.gallerylayout;
    var currentMediaId = this.currentVariant.featured_media?.id;
    // if the media id is not available and layoutstyle is not available so return false;
    if(!currentMediaId || !layoutStyle) return;

    var currentMedia = parseInt(document.querySelector(`.thumb-main-product-slider [data-media-id="${currentMediaId}"]`)?.getAttribute('data-swiper-slide-index'));
    // if current media is not available and productGallerySlider is not available so we return false
    if(!(currentMedia == 0 ? 1 : currentMedia) || !productGallerySlider) return;

    // if layout style grid and screen width greater than 992 so if block execute other wise else block.
    if (layoutStyle === 'grid' && window.screen.width >= 992) {
      var imgEl = document.querySelector(`.product-media-gallery-slider [data-media-id="${currentMediaId}"] img`); if (!imgEl) return;
      if (currentMedia == 0) {
        var imgEl = document.querySelector(`.product-media-gallery-slider [data-grid-first-image]`); if (!imgEl) return;
        var imgSrc = imgEl.dataset.gridFirstImage; if (!imgSrc) return;
      } else {
        var imgSrc = imgEl.src; if (!imgSrc) return;
      }
      var firstImageEl = document.querySelector(`.product-media-gallery-slider [data-media-index="0"] img`);
      if (!firstImageEl) return;
      firstImageEl?.removeAttribute('srcset');
      firstImageEl.src = `${imgSrc}`
    } else {
      productGallerySlider.slideTo(currentMedia, 0, false);
    }
  }

  /**
   * Update the product info when product variant change.
   */
  renderProductInfo() {
    // price update for the product info
    this.setupPriceUpdate();

    // sku update for the product info
    document.querySelector(`#Sku-${this.dataset.section}`).classList.remove('d-none');
    const skuDestination = document.querySelector(`#Sku-${this.dataset.section} [data-product-sku]`);
    skuDestination && (this.currentVariant.sku ? 
      (skuDestination.innerHTML = this.currentVariant.sku, skuDestination.classList.remove('d-none')) : 
      (skuDestination.classList.add('d-none'), document.querySelector(`#Sku-${this.dataset.section}`).classList.add('d-none')));

    // inventory status update for product info
    this.setInventoryProgressBar();

    // update cart item count
    this.updateQtyNumbers(this.currentVariant.id);

    // update the variant media
    this.updateMedia();

    // update add to cart buttons
    const isNotAvailable = this.currentVariant.available;
    this.toggleAddButton(!isNotAvailable, window.variantStrings.soldOut);
  }

  returnVarintItemCountFromCart = (varId) => {
    return window.cartStrings.cart.items.filter(item => item.id == varId ? item.quantity : 0);
  }

  updateQtyNumbers = (varId = window.productData.currentVariant.id) => {
    var cartItem = this.returnVarintItemCountFromCart(varId);
    var qtyRule = this.qtyRule;
    if(!qtyRule) return;
    if (cartItem.length) {
      var item = cartItem[0];
      if (item.quantity) {
        qtyRule.querySelector('.quantity-cart').innerHTML = item.quantity;
        qtyRule.classList.remove('d-none');
      } else {
        qtyRule.classList.add('d-none');
      }
    } else {
      qtyRule.classList.add('d-none');
    }
  }

  /**
   * Update the product price and unit price, when product variant change.
   */
  setupPriceUpdate = () => {
    const destination = document.getElementById(`price-${this.dataset.section}`);
    var isB2b = destination.querySelector('[data-volumepricingenabled]')?.dataset.volumepricingenabled == "true" ? true : false;
    if (isB2b) {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&view=qty-b2b`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        document.querySelector(`.quantity-block-${window.productData.currentProduct.id}`).innerHTML = html.body.innerHTML;
      })
      .catch((e) => console.error(e));
    } else {
      var isComparePrice = this.currentVariant.compare_at_price > this.currentVariant.price;
      var compareAtPriceWrapper = destination.querySelector('[data-compareAtPrice]');
      var compareAtPrice = destination.querySelector('[data-compareAtPrice] [data-compareAtPriceValue]');
      var onSaleBadge = destination.querySelector('[data-on-sale-badge]');
      var savingsText = onSaleBadge.dataset.savingsText;
      var actualPrice = destination.querySelector('[data-actualPrice]');
      if (isComparePrice) {
        compareAtPriceWrapper.classList.remove('d-none');
        onSaleBadge.classList.remove('d-none');
        compareAtPrice.innerHTML = Utility.formatMoney((this.currentVariant.compare_at_price), `${window.money_format}`);
        actualPrice.innerHTML = Utility.formatMoney((this.currentVariant.price), `${window.money_format}`);
        const savingsAmount = this.currentVariant.compare_at_price - this.currentVariant.price;
        const savings = Utility.formatMoney(savingsAmount, window.money_format);
        onSaleBadge.innerHTML = savingsText.replace('{{ savings }}', savings);
      } else {
        onSaleBadge.classList.add('d-none');
        compareAtPriceWrapper.classList.add('d-none');
        actualPrice.innerHTML = Utility.formatMoney((this.currentVariant.price), `${window.money_format}`);
      }
    }

    // unit per measurement
    var unitMeasurementEl = destination.querySelector('[data-unitPriceMeasurement]');
    if (this.currentVariant.unit_price_measurement != undefined) {
      var unitMeaserJSON = this.currentVariant.unit_price_measurement;
      unitMeasurementEl.classList.remove('d-none');
      unitMeasurementEl.innerHTML = `<span>${Utility.formatMoney((this.currentVariant.unit_price), `${window.money_format}`)} ${window.accessibilityStrings.unit_price_separator} ${unitMeaserJSON.reference_value != 1 ? unitMeaserJSON.reference_value : ''} ${unitMeaserJSON.reference_unit}<span>`;
    } else {
      unitMeasurementEl?.classList.add('d-none');
    }
    destination.classList.remove('d-none');
  }

  /**
   * Update the inventory progress bar when variant change.
   */
  setInventoryProgressBar = () => {
    const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
    if (this.currentVariant.inventory_management == "shopify" && inventoryDestination) {
      inventoryDestination && (inventoryDestination.classList.remove('d-none'));
      var allVariantInventory = JSON.parse(inventoryDestination.querySelector(`#ProductVariantsJSON-${inventoryDestination.dataset.productId}`).innerHTML)
      if (allVariantInventory) {
        var currentVariantInventory = parseInt(allVariantInventory[this.currentVariant.id].inventory_quantity);
        var currentVariantPolicy = allVariantInventory[this.currentVariant.id].inventory_policy;
        if (currentVariantInventory > 0) {
          var showInventoryCount = inventoryDestination.dataset.showinventorycount == "true" ? true : false;
          var inventoryThreshold = parseInt(inventoryDestination.dataset.inventorythreshold);
          var maxInventory = parseInt(inventoryDestination.dataset.maxinventory);
          if (currentVariantInventory <= inventoryThreshold) {
            if (showInventoryCount) {
              inventoryDestination.querySelector('.inventory_text').innerHTML = `${window.variantStrings.lostock_icon + window.variantStrings.inventory_low_stock_show_count.replace('{{ quantity }}', currentVariantInventory)}`; 
            } else {
              inventoryDestination.querySelector('.inventory_text').innerHTML = `${window.variantStrings.lostock_icon + window.variantStrings.inventory_low_stock}`; 
            }
          } else {
            if (showInventoryCount) {
              inventoryDestination.querySelector('.inventory_text').innerHTML = `${window.variantStrings.instock_icon + window.variantStrings.inventory_in_stock_show_count.replace('{{ quantity }}', currentVariantInventory)}`;
            } else {
              inventoryDestination.querySelector('.inventory_text').innerHTML = `${window.variantStrings.instock_icon + window.variantStrings.inventory_in_stock}`;
            }
          }
        } else {
          if (currentVariantPolicy == 'continue') {
            inventoryDestination.querySelector('.inventory_text').innerHTML = `${window.variantStrings.instock_icon + window.variantStrings.inventory_out_of_stock_continue_selling}`;
          } else {
            inventoryDestination.querySelector('.inventory_text').innerHTML = `${window.variantStrings.outofstock_icon + window.variantStrings.inventory_out_of_stock}`;
          }
        }
        var progressPercentage = (currentVariantInventory * 100) / maxInventory;
        inventoryDestination.querySelector('.progressbar-size').style.width = `${isNaN(progressPercentage) ? 0 : progressPercentage}%`;
      }
    } else {
      inventoryDestination && (inventoryDestination.classList.add('d-none'));
    }
  }

  /**
   * Handle the product form button on variant change.
   * @param {string} disable status of the ATC button
   * @param {string} text Text of the ATC button
   * @param {string} modifyClass 
   * @returns 
   */
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.removeAttribute('aria-disabled');
      productForm.querySelector('.shopify-payment-button button')?.removeAttribute('aria-disabled');
      addButtonText.classList.remove('d-none');
      productForm.querySelector('.atc-btn-wrapper span.sold-out-message')?.classList.add('d-none');
      document.querySelector('.product-form__error-message-wrapper')?.setAttribute('hidden', 'hidden');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  /**
   * Update product info when product is unavailable.
   */
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('d-none');
    if (inventory) inventory.classList.add('d-none');
    if (sku) sku.classList.add('d-none');
    if (pricePerItem) pricePerItem.classList.add('d-none');
    if (volumeNote) volumeNote.classList.add('d-none');
    if (volumeTable) volumeTable.classList.add('d-none');
    if (qtyRules) qtyRules.classList.add('d-none');
  }

  /**
   * Funcation return the list of all variant of the product
   * @returns this.variantData
   */
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);